import React, { useState, useEffect } from "react";
import LayoutContainer from "../../FUSComponents/LayoutContainer/LayoutContainer";
import { FUSButton } from "../../FUSComponents/FUSElements/FUSButton/FUSButton";
import { useMediaQuery } from "react-responsive";
import ManageOfferLOB from "./ManageOfferLOB";
import OfferLOBCategoryMap from "./OfferLOBCategoryMap";


const OfferLOBConfiguration = () => {
  const [view, setView] = useState("LOB");

  const isMobile = useMediaQuery({ minWidth: 200, maxWidth: 576 })

  useEffect(() => {
    renderComponent();
  }, [view]);

  const renderComponent = () => {
    if (view === "LOB") {
      return <ManageOfferLOB />;
    } else if (view === "CATEGORY") {
      return <OfferLOBCategoryMap />;
    }
  };
  return (
    <>
      <LayoutContainer
        title1="Vendor"
        title2="Vendor"
        title3={
          view === "LOB"
            ? "Manage OfferLOB"
            : view === "CATEGORY"
              ? "LOB-Category Mapping" : ""
              
        }
        right={
          <>
            <div className="d-flex gap-3">
            <FUSButton
                labelText={isMobile ? "LOB" : "Manage OfferLOB"}
                buttonType={view === "LOB" ? "primary" : "secondary"}
                onClick={() => setView("LOB")}
              />
              <FUSButton
                labelText={isMobile ? "Category" : "LOB-Category Mapping"}
                buttonType={view === "CATEGORY" ? "primary" : "secondary"}
                onClick={() => setView("CATEGORY")}
              />
           
            </div>
          </>
        }
      >
        {renderComponent()}
      </LayoutContainer>
    </>
  );
};

export default OfferLOBConfiguration;
